import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetUserPasswordMutation } from '@src/features/profile/redux';
import { ArcStack, ArcText, ArcBox } from '@src/core/ui';
import { MyProfileProps } from './types';
import { useDisclosure } from '@src/core/hooks';
import { IUserChangePasswordForm } from '@src/features/profile/entites';
import { toast } from 'react-toastify';
import { ChangePasswordForm, HubContent, ProfileContent } from '@src/features/profile/components';
import { useGetUserDataQuery } from '@src/core/features';
import { routesConfig } from '@src/core/routes';

const MyProfile: React.FC<MyProfileProps> = () => {
  const navigate = useNavigate();
  const { open, show, hide } = useDisclosure();
  const [ setPassword, { isLoading: isSubmitting } ] = useSetUserPasswordMutation();
  const { data, isLoading } = useGetUserDataQuery();

  const onSetPassword = (form: IUserChangePasswordForm) => {
    setPassword(form).unwrap().then(() => {
      toast.success('Set Password Success Text');
      hide();
    }).catch(() => {});
  };

  return (
    <React.Fragment>
      <ArcStack 
        pt={8}
        direction='row'
        alignItems='flex-start'
        justifyContent='center'>

        <ArcStack
          spacing={2}
          width='100%'
          maxWidth={700}>

          <ProfileContent 
            profile={data} 
            isLoading={isLoading} 
            onClickPassword={show} />

          <HubContent 
            profile={data} 
            isLoading={isLoading} />
        </ArcStack>
    
      </ArcStack>

      <ArcStack
        component="footer"
        direction="row"
        spacing={6}
        pt={2}
        pb={2}
        mt={3}
        justifyContent="center"
        alignItems="center"
        sx={{ backgroundColor: 'background.paper' }}
      >
        <ArcBox
          component="div"
          role="button"
          tabIndex={0}
          onClick={() => navigate(`${routesConfig.profile}/terms`)}
          onKeyDown={(e) => e.key === 'Enter' && navigate(`${routesConfig.profile}/terms`)}
          sx={{ cursor: 'pointer' }}
        >
          <ArcText fontSize={14} color="white">
            Terms and conditions
          </ArcText>
        </ArcBox>
        <ArcBox
          component="div"
          role="button"
          tabIndex={0}
          onClick={() => navigate(`${routesConfig.profile}/privacy`)}
          onKeyDown={(e) => e.key === 'Enter' && navigate(`${routesConfig.profile}/privacy`)}
          sx={{ cursor: 'pointer' }}
        >
          <ArcText fontSize={14} color="white">
            Privacy policy
          </ArcText>
        </ArcBox>
      </ArcStack>

      <ChangePasswordForm 
        open={open} 
        onClose={hide} 
        onSubmit={onSetPassword}
        isSubmitting={isSubmitting}
      />
    </React.Fragment>
  );
};

export default MyProfile;